import api from 'api';
import utils from 'utils';
import actions from 'actions';

const login = user => {
  return api.user.login({ email: user.email, password: user.password }).then(response => {
    window.user = response.data.user;
    window.user.isLogged = true;

    utils.storage.local.set('user', window.user);
    actions.event('login').call(response);

    return response.data.user;
  });
};

const logout = () => {
  window.user = {};

  utils.storage.local.set('user', window.user);
  actions.event('logout').call();
};

const getWithNotificationToken = () => {
  return api.user.getWithNotificationToken().then(x => x.data.users);
};

const updateSubscription = user => {
  return api.user.updateSubscription(user).then(x => x.data);
};

const getMarketingFollowInstagram = () => {
  return api.user.getMarketingFollowInstagram().then(x => x.data);
};

const setMarketingFollowInstagramAsDoneById = userId => {
  return api.user.setMarketingFollowInstagramAsDoneById(userId).then(x => x.data);
};

const getSubscribers = () => {
  return api.user.getSubscribers().then(x => x.data.users);
};

const actionsUser = {
  login,
  logout,
  getSubscribers,
  getWithNotificationToken,
  updateSubscription,
  getMarketingFollowInstagram,
  setMarketingFollowInstagramAsDoneById,
};

export default actionsUser;
